"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.byId = byId;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _find = _interopRequireDefault(require("lodash/find"));
var _includes = _interopRequireDefault(require("lodash/includes"));
var _findKey = _interopRequireDefault(require("lodash/findKey"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _map = _interopRequireDefault(require("lodash/map"));
var _transform = _interopRequireDefault(require("lodash/transform"));
var _settings = require("../../settings");
var _common = require("./common");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getCustomValidationMessages = function getCustomValidationMessages(option, choices) {
  var _getSettings = (0, _settings.getSettings)(),
    customValidators = _getSettings.customValidators;
  var validate = customValidators && customValidators[option.optionType];
  if (validate) {
    var optionChoice = (0, _find["default"])(option.choices.map(function (cid) {
      return choices[cid];
    }), 'isSelected');
    return validate({
      option: option,
      optionChoice: optionChoice
    });
  }
  return [];
};
var isThereAValidChoiceSelected = function isThereAValidChoiceSelected(choices, option, selectedChoices, disabledChoices) {
  var newChoiceSelected = (0, _findKey["default"])(choices, function (choice) {
    return option.choices.indexOf(choice.id) >= 0 && selectedChoices.indexOf(choice.id) >= 0;
  });
  var noActiveSelectedChoice = option.choices.every(function (choiceId) {
    return !choices[choiceId].isSelected || choices[choiceId].value === '' || !choices[choiceId].isActive || disabledChoices.indexOf(choiceId) >= 0;
  });
  return !noActiveSelectedChoice || newChoiceSelected;
};
var getOopsMessage = function getOopsMessage(saveAttempts, option, choices, disabledChoices, selectedChoices, isActive) {
  var _getSettings2 = (0, _settings.getSettings)(),
    alwaysShowOopsMessage = _getSettings2.alwaysShowOopsMessage;
  var needsOops = option.isRequired && isActive && (alwaysShowOopsMessage || saveAttempts > 0) && !isThereAValidChoiceSelected(choices, option, selectedChoices, disabledChoices);
  return needsOops ? [(0, _common.oops)()] : [];
};
var getServerMessages = function getServerMessages(responseMessages, optionId) {
  var matchingMessages = responseMessages.filter(function (message) {
    return (0, _includes["default"])(message.affectedOptions, optionId.toString());
  });
  return matchingMessages.map(function (match) {
    return {
      message: match.message,
      messageType: match.type
    };
  });
};

// eslint-disable-next-line
var buildLatestMessages = function buildLatestMessages(option, choices, messages, optionId, saveAttempts, disabledChoices, selectedChoices, isActive) {
  return [].concat((0, _toConsumableArray2["default"])(getOopsMessage(saveAttempts, option, choices, disabledChoices, (0, _map["default"])(selectedChoices, 'choiceId'), isActive)), (0, _toConsumableArray2["default"])(getCustomValidationMessages(option, choices)), (0, _toConsumableArray2["default"])(getServerMessages(messages, optionId)));
};

// eslint-disable-next-line import/prefer-default-export
function byId(state, _ref) {
  var data = _ref.data,
    choices = _ref.choices,
    saveAttempts = _ref.saveAttempts;
  var messages = data.messages,
    disabledOptions = data.disabledOptions,
    disabledChoices = data.disabledChoices,
    selectedChoices = data.selectedChoices;
  return (0, _transform["default"])(state.allIds, function (newState, optionId) {
    var option = state[optionId];
    var isActive = !(0, _includes["default"])(disabledOptions, optionId);
    var updatedMessages = buildLatestMessages(option, choices, messages, optionId, saveAttempts, disabledChoices, selectedChoices, isActive);
    if (state[optionId].isActive !== isActive || !(0, _isEqual["default"])(updatedMessages, option.messages)) {
      // eslint-disable-next-line no-param-reassign
      newState[optionId] = _objectSpread(_objectSpread({}, option), {}, {
        isActive: isActive,
        messages: updatedMessages
      });
    }
  }, _objectSpread({}, state));
}
//# sourceMappingURL=executeRulesSuccess.js.map